import React, { useState, useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Formik } from "formik";
import Modal from "react-bootstrap/Modal";
import styles from "./styles.module.css";
import { SignatureSchema } from "validations/Users";
import {
  Button,
  Container,
  Row,
  Col,
  Nav,
  Navbar,
  Card,
  Badge,
  FormGroup,
  Spinner,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import storage from "helpers/storage";
import { useNavigate } from "react-router-dom";
import { changeSignature, getUserDetails } from "services/userService";
import { toast } from "react-toastify";
import { MESSAGES } from "constants/messages";
export const ManageSignature = ({ showSign, handleSignModalClose }) => {
  let [data, setData] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [userSignature, setUserSignature] = useState("");
 

  const userInformation: any = storage.getData("user-info");
  const userId = userInformation.id;
  let sigCanvas = useRef<any>({});
  const initialValuesSign = {
    sign: "",
  };

  function setSignatureOnChange() {
    setData(sigCanvas?.current?.toDataURL("image/png"));
  }
  useEffect(() => {
    if (storage.getToken() != null) {
      getUserData();
    }
  }, []);
  const getUserData = async () => {
    setLoading(true);
    getUserDetails({ userId })
      .then((response) => {
        setLoading(false);
        setUserSignature(response?.data?.signature);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const submitSignatureForm = async () => {
    setBtnLoading(true);
    let signature = data;
    changeSignature({ userId, signature })
      .then((response) => {
       
        setBtnLoading(false)
        toast.success(MESSAGES.signatureUploaded);
        window.location.reload();
        handleSignModalClose();
      })
      .catch((error) => {
        setBtnLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };


  return (
    <div>
      <Modal
        show={showSign}
        onHide={handleSignModalClose}
        centered
        dialogClassName="modal-1029w"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-25 fw-bold">My Signature</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={SignatureSchema}
            initialValues={initialValuesSign}
            onSubmit={submitSignatureForm}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
            }) => (
              <Form className="text-start" noValidate onSubmit={handleSubmit}>
                <div className={styles.sigContainer}>
                  <SignatureCanvas
                    ref={sigCanvas}
                    penColor="black"
                    canvasProps={{ className: styles.sigPad }}
                    onEnd={setSignatureOnChange}
                  />
                  <p>
                    Sign here using MOUSE or TOUCH screen if using a tablet.
                  </p>
                </div>
                {loading ?  <div> <Form.Group className="mt-3 text-center">
                <Spinner animation="grow" size="sm" variant="warning" />
                <Spinner animation="grow" size="sm" variant="danger" />
                <Spinner animation="grow" size="sm" variant="warning" />
              </Form.Group></div>:
                <div>
                    
                    <label className="mt-2 fs-18 fw-bold">Existing Signature</label>
                  {userSignature ? (
                    <img className={styles.sigImage} src={userSignature} />
                  ) : (
                    <div>No Signature</div>
                  )}
                </div>}
                <div className="d-flex justify-content-end mt-4">
                <Button
                    variant="outline-secondary"
                    className="me-2 fs-15 fw-semibold "
                    onClick={handleSignModalClose}
                  >
                    Cancel
                  </Button>
                  {btnLoading ?  <Button
                    variant="primary"
                    className="fs-15 fw-semibold text-black"
                    type="button"
                    disabled
                  >
                    <Spinner size="sm" />
                  </Button>:
                  <Button
                    variant="primary"
                    className="fs-15 fw-semibold text-black"
                    type="button"
                    onClick={submitSignatureForm}
                  >
                    Submit
                  </Button>}
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
        
      </Modal>
    </div>
  );
};
